module.exports = __webpack_public_path__ + "img/IMG_8925.91b8a97e.jpg";